import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunction from "../Data.Function/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dNumber from "../Data.Number/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dString$dRegex from "../Data.String.Regex/index.js";
import * as Data$dString$dRegex$dFlags from "../Data.String.Regex.Flags/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Partial from "../Partial/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
const FormField = x => x;
const Conversion = x => x;
const semigroupoidConversion = {
  compose: v => v1 => (
    {
      fromInitial: x => v.fromInitial(v1.fromInitial(x)),
      toFinal: x => {
        const $0 = v.toFinal(x);
        if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
        if ($0.tag === "Right") { return v1.toFinal($0._1); }
        $runtime.fail();
      }
    }
  )
};
const phoneRE = /* #__PURE__ */ (() => {
  const $0 = Data$dString$dRegex.regex("^\\+?[0-9 -]+$")(Data$dString$dRegex$dFlags.noFlags);
  if ($0.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($0._1)); }
  if ($0.tag === "Right") { return $0._1; }
  $runtime.fail();
})();
const nonNothingConversion = errorMsg => (
  {
    fromInitial: x => x,
    toFinal: x => {
      if (
        (() => {
          if (x.tag === "Nothing") { return true; }
          if (x.tag === "Just") { return false; }
          $runtime.fail();
        })()
      ) {
        return Data$dEither.$Either("Left", [errorMsg]);
      }
      return Data$dEither.$Either("Right", x);
    }
  }
);
const nonEmptyStringConversion = errorMsg => (
  {
    fromInitial: x => x,
    toFinal: x => {
      if (Data$dString$dCommon.trim(x) === "") { return Data$dEither.$Either("Left", [errorMsg]); }
      return Data$dEither.$Either("Right", x);
    }
  }
);
const nonEmptyArrayConversion = errorMessage => (
  {
    fromInitial: x => x,
    toFinal: x => {
      if (Data$dFoldable.foldrArray(v => v1 => false)(true)(x)) { return Data$dEither.$Either("Left", [errorMessage]); }
      return Data$dEither.$Either("Right", x);
    }
  }
);
const noFieldState = {
  submitOccured: Specular$dFRP$dBase.never,
  remoteErrors: /* #__PURE__ */ (() => {
    const n = Specular$dInternal$dIncremental.constant([]);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })()
};
const newFormFieldEDyn = dictMonadFRP => conversion => remoteState => initial => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dRef.new(dictMonadFRP.MonadEffect0())(initial))(ref => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dCallback.newCallback(dictMonadFRP.MonadEffect0()))(focusOutCallback1 => dictMonadFRP.MonadCleanup1().Monad0().Bind1().bind(Specular$dFRP$dBase.foldDyn(dictMonadFRP)(x => v => x)(false)(Specular$dFRP$dBase.leftmost([
  Specular$dFRP$dBase.functorEvent.map(v => true)(focusOutCallback1.event),
  Specular$dFRP$dBase.functorEvent.map(v => true)(remoteState.submitOccured)
])))(isTouched1 => dictMonadFRP.MonadCleanup1().Monad0().Applicative0().pure({
  editRef: ref,
  focusOutCallback: focusOutCallback1.callback,
  finalValue: Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(Data$dFunction.apply)(Specular$dFRP$dBase.functorDynamic.map(v => v.toFinal)(conversion)))(ref._1),
  isTouched: isTouched1,
  remoteState
}))));
const newFormFieldE = dictMonadFRP => conversion => remoteState => initial => newFormFieldEDyn(dictMonadFRP)((() => {
  const n = Specular$dInternal$dIncremental.constant(conversion);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})())(remoteState)(initial);
const newFormField = dictMonadFRP => v => remoteState => initial => newFormFieldE(dictMonadFRP)(v)(remoteState)(v.fromInitial(initial));
const moneyRE = /* #__PURE__ */ (() => {
  const $0 = Data$dString$dRegex.regex("^-?[0-9]+([,\\.][0-9]{2})?$")(Data$dString$dRegex$dFlags.noFlags);
  if ($0.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($0._1)); }
  if ($0.tag === "Right") { return $0._1; }
  $runtime.fail();
})();
const maybeStringConversion = {
  fromInitial: v2 => {
    if (v2.tag === "Nothing") { return ""; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  },
  toFinal: v => {
    if (v === "") { return Data$dEither.$Either("Right", Data$dMaybe.Nothing); }
    return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", v));
  }
};
const maybeConversion = errorMessage => (
  {
    fromInitial: Data$dMaybe.Just,
    toFinal: v => {
      if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
      if (v.tag === "Nothing") { return Data$dEither.$Either("Left", [errorMessage]); }
      $runtime.fail();
    }
  }
);
const isTouched = v => v.isTouched;
const intConversion = errorMessage => (
  {
    fromInitial: Data$dShow.showIntImpl,
    toFinal: e => {
      const v = Data$dInt.fromString(e);
      if (v.tag === "Nothing") { return Data$dEither.$Either("Left", [errorMessage]); }
      if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
      $runtime.fail();
    }
  }
);
const intPercentageConversion = v => {
  const $0 = v.percentageError;
  return semigroupoidConversion.compose(intConversion(v.numError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x >= 0 && x <= 100) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const nonNegativeIntConversion = v => {
  const $0 = v.nonNegativeIntError;
  return semigroupoidConversion.compose(intConversion(v.intError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x >= 0) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const positiveIntConversion = v => {
  const $0 = v.positiveIntError;
  return semigroupoidConversion.compose(intConversion(v.intError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x > 0) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const rangeIntConversion = v => {
  const $0 = v.rangeIntError;
  const $1 = v.max;
  const $2 = v.min;
  return semigroupoidConversion.compose(intConversion(v.intError))({
    fromInitial: x => x,
    toFinal: x => {
      if ($1 >= x && x >= $2) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const fromValidV = v2 => {
  if (v2.tag === "Left") { return Data$dMaybe.Nothing; }
  if (v2.tag === "Right") { return Data$dMaybe.$Maybe("Just", v2._1); }
  $runtime.fail();
};
const focusOutCallback = v => v.focusOutCallback;
const finalValueNoErr = v => Specular$dFRP$dBase.functorDynamic.map(v2 => {
  if (v2.tag === "Nothing") { return Data$dEither.$Either("Left", Restaumatic$dForm$dFinal.unknownError); }
  if (v2.tag === "Just") { return Data$dEither.$Either("Right", v2._1); }
  $runtime.fail();
})(Specular$dFRP$dBase.functorDynamic.map(fromValidV)(v.finalValue));
const finalValue = v => v.finalValue;
const fieldStateEmpty = formState => (
  {
    submitOccured: formState.submitOccured,
    remoteErrors: (() => {
      const n = Specular$dInternal$dIncremental.constant([]);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })()
  }
);
const emptyConversion = dictMonoid => dictEq => v => (
  {
    fromInitial: (() => {
      const $0 = dictMonoid.mempty;
      return v2 => {
        if (v2.tag === "Nothing") { return $0; }
        if (v2.tag === "Just") { return v.fromInitial(v2._1); }
        $runtime.fail();
      };
    })(),
    toFinal: x => {
      if (dictEq.eq(x)(dictMonoid.mempty)) { return Data$dEither.$Either("Right", Data$dMaybe.Nothing); }
      const $0 = v.toFinal(x);
      if ($0.tag === "Left") { return Data$dEither.$Either("Left", $0._1); }
      if ($0.tag === "Right") { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", $0._1)); }
      $runtime.fail();
    }
  }
);
const emailRE = /* #__PURE__ */ (() => {
  const $0 = Data$dString$dRegex.regex("^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\\.[a-zA-Z0-9-]+)+$")(Data$dString$dRegex$dFlags.noFlags);
  if ($0.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($0._1)); }
  if ($0.tag === "Right") { return $0._1; }
  $runtime.fail();
})();
const editRef = v => v.editRef;
const formFieldValue = x => x.editRef._1;
const doesPhoneMatchRegex = /* #__PURE__ */ Data$dString$dRegex.test(phoneRE);
const maybePhoneConversion = errorMsg => (
  {
    fromInitial: v2 => {
      if (v2.tag === "Nothing") { return ""; }
      if (v2.tag === "Just") { return v2._1; }
      $runtime.fail();
    },
    toFinal: x => {
      const xt = Data$dString$dCommon.trim(x);
      if (xt === "") { return Data$dEither.$Either("Right", Data$dMaybe.Nothing); }
      if (doesPhoneMatchRegex(xt)) { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", xt)); }
      return Data$dEither.$Either("Left", [errorMsg]);
    }
  }
);
const phoneConversion = errorMsg => (
  {
    fromInitial: x => x,
    toFinal: x => {
      const xt = Data$dString$dCommon.trim(x);
      if (doesPhoneMatchRegex(xt)) { return Data$dEither.$Either("Right", xt); }
      return Data$dEither.$Either("Left", [errorMsg]);
    }
  }
);
const doesMoneyMatchRegex = /* #__PURE__ */ Data$dString$dRegex.test(moneyRE);
const moneyConversion = errorMessage => (
  {
    fromInitial: Data$dMoney$dRounded.toString,
    toFinal: x => {
      const v = Data$dMoney$dRounded.fromString(Data$dString$dCodeUnits.contains(".")(x) ? x : Data$dString$dCommon.replace(",")(".")(x));
      if (doesMoneyMatchRegex(x)) {
        if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
        return Data$dEither.$Either("Left", [errorMessage]);
      }
      return Data$dEither.$Either("Left", [errorMessage]);
    }
  }
);
const nonNegativeMoneyConversion = v => {
  const $0 = v.nonNegativeMoneyError;
  return semigroupoidConversion.compose(moneyConversion(v.moneyError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x >= 0) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const positiveMoneyConversion = v => {
  const $0 = v.positiveMoneyError;
  return semigroupoidConversion.compose(moneyConversion(v.moneyError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x > 0) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const doesEmailMatchRegex = /* #__PURE__ */ Data$dString$dRegex.test(emailRE);
const emailConversion = errorMsg => (
  {
    fromInitial: x => x,
    toFinal: x => {
      const xt = Data$dString$dCommon.trim(x);
      if (doesEmailMatchRegex(xt)) { return Data$dEither.$Either("Right", xt); }
      return Data$dEither.$Either("Left", [errorMsg]);
    }
  }
);
const maybeEmailConversion = errorMsg => (
  {
    fromInitial: v2 => {
      if (v2.tag === "Nothing") { return ""; }
      if (v2.tag === "Just") { return v2._1; }
      $runtime.fail();
    },
    toFinal: x => {
      const xt = Data$dString$dCommon.trim(x);
      if (xt === "") { return Data$dEither.$Either("Right", Data$dMaybe.Nothing); }
      if (doesEmailMatchRegex(xt)) { return Data$dEither.$Either("Right", Data$dMaybe.$Maybe("Just", xt)); }
      return Data$dEither.$Either("Left", [errorMsg]);
    }
  }
);
const displayedErrors = v => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map($$final => remote => isTouched$p => Data$dSemigroup.concatArray((() => {
  if (isTouched$p) {
    if ($$final.tag === "Left") { return $$final._1; }
    if ($$final.tag === "Right") { return []; }
    $runtime.fail();
  }
  return [];
})())(remote))(v.finalValue))(v.remoteState.remoteErrors))(v.isTouched);
const decimalRE = /* #__PURE__ */ (() => {
  const $0 = Data$dString$dRegex.regex("^-?[0-9]+([,\\.][0-9]+)?$")(Data$dString$dRegex$dFlags.noFlags);
  if ($0.tag === "Left") { return Partial._crashWith(Data$dShow.showStringImpl($0._1)); }
  if ($0.tag === "Right") { return $0._1; }
  $runtime.fail();
})();
const doesNumberMatchRegex = /* #__PURE__ */ Data$dString$dRegex.test(decimalRE);
const numberConversion = errorMessage => (
  {
    fromInitial: Data$dShow.showNumberImpl,
    toFinal: e => {
      const v = Data$dNumber.fromStringImpl(
        Data$dString$dCodeUnits.contains(".")(e) ? e : Data$dString$dCommon.replace(",")(".")(e),
        Data$dNumber.isFinite,
        Data$dMaybe.Just,
        Data$dMaybe.Nothing
      );
      if (doesNumberMatchRegex(e)) {
        if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
        return Data$dEither.$Either("Left", [errorMessage]);
      }
      return Data$dEither.$Either("Left", [errorMessage]);
    }
  }
);
const nonNegativeNumberConversion = v => {
  const $0 = v.nonNegativeNumError;
  return semigroupoidConversion.compose(numberConversion(v.numError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x >= 0.0) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const percentageConversion = v => {
  const $0 = v.percentageError;
  return semigroupoidConversion.compose(numberConversion(v.numError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x >= 0.0 && x <= 100.0) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const positiveNumberConversion = v => {
  const $0 = v.positiveNumError;
  return semigroupoidConversion.compose(numberConversion(v.numError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x > 0.0) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
const categoryConversion = {identity: {fromInitial: x => x, toFinal: x => Data$dEither.$Either("Right", x)}, Semigroupoid0: () => semigroupoidConversion};
const atPath = path => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordArray(Data$dOrd.ordString))(path);
  return x => {
    const $1 = $0(x);
    if ($1.tag === "Nothing") { return []; }
    if ($1.tag === "Just") { return $1._1; }
    $runtime.fail();
  };
};
const fieldState = path => formState => ({submitOccured: formState.submitOccured, remoteErrors: Specular$dFRP$dBase.functorDynamic.map(atPath(path))(formState.remoteErrors)});
const arrayStripPrefix = dictEq => prefix => input => {
  if (
    Data$dEq.eqArrayImpl(dictEq.eq)((() => {
      const $0 = prefix.length;
      if ($0 < 1) { return []; }
      return Data$dArray.slice(0)($0)(input);
    })())(prefix)
  ) {
    return Data$dMaybe.$Maybe(
      "Just",
      (() => {
        const $0 = prefix.length;
        if ($0 < 1) { return input; }
        return Data$dArray.slice($0)(input.length)(input);
      })()
    );
  }
  return Data$dMaybe.Nothing;
};
const stripPathPrefix = prefix => {
  const $0 = Data$dMap$dInternal.fromFoldable(Data$dOrd.ordArray(Data$dOrd.ordString))(Data$dFoldable.foldableArray);
  const $1 = Data$dArray.mapMaybe(v => Data$dMaybe.applyMaybe.apply((() => {
    const $1 = arrayStripPrefix(Data$dEq.eqString)(prefix)(v._1);
    if ($1.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dTuple.Tuple($1._1)); }
    return Data$dMaybe.Nothing;
  })())(Data$dMaybe.$Maybe("Just", v._2)));
  return x => $0($1(Data$dMap$dInternal.toUnfoldable(Data$dUnfoldable.unfoldableArray)(x)));
};
const focusFormState = path => formState => (
  {submitOccured: formState.submitOccured, remoteErrors: Specular$dFRP$dBase.functorDynamic.map(stripPathPrefix(path))(formState.remoteErrors)}
);
const anyPercentageConversion = v => {
  const $0 = v.percentageError;
  return semigroupoidConversion.compose(numberConversion(v.numError))({
    fromInitial: x => x,
    toFinal: x => {
      if (x >= -100.0 && x <= 100.0) { return Data$dEither.$Either("Right", x); }
      return Data$dEither.$Either("Left", [$0]);
    }
  });
};
export {
  Conversion,
  FormField,
  anyPercentageConversion,
  arrayStripPrefix,
  atPath,
  categoryConversion,
  decimalRE,
  displayedErrors,
  doesEmailMatchRegex,
  doesMoneyMatchRegex,
  doesNumberMatchRegex,
  doesPhoneMatchRegex,
  editRef,
  emailConversion,
  emailRE,
  emptyConversion,
  fieldState,
  fieldStateEmpty,
  finalValue,
  finalValueNoErr,
  focusFormState,
  focusOutCallback,
  formFieldValue,
  fromValidV,
  intConversion,
  intPercentageConversion,
  isTouched,
  maybeConversion,
  maybeEmailConversion,
  maybePhoneConversion,
  maybeStringConversion,
  moneyConversion,
  moneyRE,
  newFormField,
  newFormFieldE,
  newFormFieldEDyn,
  noFieldState,
  nonEmptyArrayConversion,
  nonEmptyStringConversion,
  nonNegativeIntConversion,
  nonNegativeMoneyConversion,
  nonNegativeNumberConversion,
  nonNothingConversion,
  numberConversion,
  percentageConversion,
  phoneConversion,
  phoneRE,
  positiveIntConversion,
  positiveMoneyConversion,
  positiveNumberConversion,
  rangeIntConversion,
  semigroupoidConversion,
  stripPathPrefix
};
